import { render, staticRenderFns } from "./account_xq.vue?vue&type=template&id=ffc63dd2&scoped=true&"
import script from "./account_xq.vue?vue&type=script&lang=js&"
export * from "./account_xq.vue?vue&type=script&lang=js&"
import style0 from "./account_xq.vue?vue&type=style&index=0&id=ffc63dd2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffc63dd2",
  null
  
)

export default component.exports